import store from "~/modules/auth/services/redux/store"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { LanguageProvider } from "./languages/LanguageProvider"
import App from "./App"
import "./index.css"
import { ConfigProvider } from "antd"

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <LanguageProvider>
      <ConfigProvider
        theme={{
          components: {
            Menu: {
              itemMarginInline: 0,
            },
          },
        }}
      >
        <StrictMode>
          <App />
        </StrictMode>
      </ConfigProvider>
    </LanguageProvider>
  </Provider>,
)
